export default __webpack_public_path__ + "static/media/admin_icon_user.86c887fc.svg";